<template>
	<div class="ReSelectCascade">		
		<div class="row">
			<el-select
				class="col-md-12 select-primary"
				size="large"                
				placeholder="Тип жилья"
				filterable
				clearable
				v-model="value.houseTypeList"
				@change="onType"
			>
				<el-option
					v-for="(el_opt, el_index) in cat_objects_category"
					class="select-primary"
					:value="el_opt.value"
					:label="el_opt.label"
					:key="el_index"                    
				>
				</el-option>
			</el-select>
		</div>
		<div class="row">
			<el-select
				class="col-md-12 select-primary overflow-overlay"
				size="large"                
				placeholder="Комнатность"
				v-model="value.houseRoomsList"
				multiple
				clearable
			>
				<el-option
					v-for="(room, el_index) in cat_objects"
					class="select-primary"
					:value="room.value"
					:label="room.label"
					:key="el_index"
				>
				</el-option>
			</el-select>
		</div>
	</div>
</template>

<script>
	import { Select, Option } from 'element-ui';
	export default {
		name: 'ReSelectCascadeObjCategory',
		components: {
			[Option.name]: Option,
			[Select.name]: Select,
		},
		props: {
			value: {
				type: Object,
				default() {	return {
					houseTypeList:'',
					houseRoomsList:'',					
				}; }
			},
			findId: {
				type: String,
				default: '',
			},
			required:{
				type: Boolean,
				default: false
			},
			
		},
		data () {
			return {
				ver: 1,	
				cat_objects: [],  
				cat_objects_category: [],
				objCurHouseTypes: {},
			}
		},
		computed: {

		},
		watch:{
			value(val){
				if(typeof this.$GVO.cats.cat_objects != 'undefined' && typeof this.$GVO.cats.cat_objects != 'undefined'){
					this.setCat();
				}
			}
		},
		methods: {
			onType(houseType,bForce=false){
				if(!bForce){
					this.value.houseRoomsList = '';
				}
				//console.log(houseType,this.$GVO.cats.cat_objects);
				this.cat_objects = [];
				for (let i = 0; i < this.$GVO.cats.cat_objects.length; i++) {
					if(this.$GVO.cats.cat_objects[i].category == houseType){
						this.cat_objects.push({'value':this.$GVO.cats.cat_objects[i].id.toString(),'label':this.$GVO.cats.cat_objects[i].name});
					}
				}
				
			},
			setCat(){
				// console.log(this.$GVO.cats.cat_objects_category);
				this.cat_objects_category = [];
				for (let i = 0; i < this.$GVO.cats.cat_objects_category.length; i++) {
					this.cat_objects_category.push({'value':this.$GVO.cats.cat_objects_category[i].id.toString(),'label':this.$GVO.cats.cat_objects_category[i].name});
				}

				for (let i = 0; i < this.cat_objects_category.length; i++){
					if(this.value.houseTypeList == this.cat_objects_category[i].value){
						this.objCurHouseTypes.houseType = this.cat_objects_category[i].label;
						// console.log(this.objCurHouseTypes);
					}
				}

				if(this.value.houseTypeList != ''){
					this.onType(this.value.houseTypeList,true);					
					
				}
			},
		},
		mounted() {
			if(typeof this.$GVO.cats.cat_objects != 'undefined' && typeof this.$GVO.cats.cat_objects != 'undefined'){
				this.setCat();
			}else{
				this.$GVO.LoadCatPromise('cat_objects_category')
				.then((objApi) => {		
					if(objApi === true){
						this.$GVO.LoadCatPromise('cat_objects')
							.then((objApi) => {		
								if(objApi === true){
									this.setCat();
								}
							}).catch(errorObjApi => {console.error(errorObjApi);});
					}
				}).catch(errorObjApi => {console.error(errorObjApi);});
			}
		}
	}
</script>
<style scoped>
.white-content .el-input input::placeholder {color:#222a42;} 
.white-content .form-options-group  >>> .el-input__inner::placeholder {color:#222a42;} 
</style>
